export default __webpack_public_path__ + "static/tape-70d606a5bde50f9b4d2c52b94543a318.mp3";